import { checkIfFileExists } from "../../services/real-star-api/file/file-checker";
import { uploadFile } from "../../services/real-star-api/file/upload-file";
import { createFormData, getExistingFileName } from "../../utils/utilities";


export const uploadPartiesFiles = async (mainValues, transactionID, userEncryptedID, dispatch , setAlert) => {
    // upload files.
    const fieldWithFiles = Object.keys(mainValues).filter(i => i.includes("File"));
    let fileLinks = {};

    if (fieldWithFiles.length > 0) {
        // Create an array of promises for each file upload
        const uploadPromises = fieldWithFiles.map(async (i) => {
            let newFileName = i.replace(/\s+/g, ''); // remove spacing
            const isFile = (property) => property instanceof File;

            //if new file or raw file
            if (isFile(mainValues[i]) || mainValues[i].size) {
                const formData = createFormData(mainValues[i], newFileName, transactionID);

                try {
                    const link = await uploadFile(formData, userEncryptedID?.encrypted_id);
                    fileLinks = { ...fileLinks, [i]: {name: link.split('/').pop() , link: link } };
                } catch (error) {
                    console.error(`Error uploading file for field ${i}:`, error);
                }
            }
        });
        //show modal for the completed transaction.
        dispatch(setAlert({
            show: true,
            title: 'Processing Form Submission',
            body: `The attached file is currently uploading <br/><br/> Kindly wait a moment.`,
            showBtn: false
        }))
        // Wait for all uploads to complete
        await Promise.all(uploadPromises);
    }

    return fileLinks 
}


export const uploadOTPDocs = async (file , transactionID , userDetails) => {

    const existingFileName = getExistingFileName(file?.fileName)
    const existingFileURL = await checkIfFileExists(transactionID, existingFileName);

    if(!(existingFileURL)){
        const userEncryptedID = userDetails?.encrypted_id
        const newFileName = file.fileName?.replace(/\s+/g, '');
        const actualFile = file.actualFile

        const formData = createFormData(actualFile , newFileName, transactionID)
        try {
            const otpLink = await uploadFile(formData, userEncryptedID);
            return otpLink?.replace(/\.[^/.]+$/, ''); //remove extra extension file name
        } 
        catch (err) {
            console.error('Upload error:', err);
            throw err;

        }
    }else{
        console.log("with existing OTP Document")
        return existingFileURL;
    }
}
